module.exports = __webpack_public_path__ + "static/img/grantbassett_circle150.1aba88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/grantbassett_circle150.png
// module id = jb+z
// module chunks = 0